<template>
  <div class="product-detail min-h-screen">
    <Headers />
    <div class="max-w-7xl mx-auto px-4 py-8">
      <div class="rounded-lg overflow-hidden">
        <div class="grid md:grid-cols-5 gap-8">
          <!-- 左侧：图片展示 -->
          <div class="space-y-4 md:col-span-2">
            <ProductCarousel
              :carousel="currentProductDetails.carousel"
            ></ProductCarousel>
          </div>

          <!-- 右侧：产品信息 -->
          <div class="space-y-6 md:col-span-3">
            <!-- 产品名称 -->
            <div>
              <h1 class="text-3xl font-bold text-gray-900 mb-2">
                {{ currentProductDetails.name }}
              </h1>
              <p class="text-gray-500">{{ currentProductDetails.sub_title }}</p>
            </div>

            <!-- 产品描述 -->
            <div class="border-t pt-4">
              <p class="text-gray-700 leading-relaxed">
                {{ currentProductDetails.description || "--" }}
              </p>
            </div>

            <!-- 操作按钮 -->
            <div class="space-y-3 pt-4">
              <button
                @click="addToCart(currentProductDetails.amazon_link)"
                class="w-48 py-2 rounded-full text-white font-semibold transition-all"
                style="background-color: #e7930f"
              >
                BUY ON AMAZON
              </button>
            </div>
          </div>
        </div>
        <!-- 详细信息标签页 -->
        <div>
          <div class="max-w-7xl mx-auto">
            <!-- 标签导航 -->
            <div class="flex border-b">
              <button
                :class="[
                  'px-8 py-4 font-medium transition-colors border-b-2 border-blue-500 text-blue-600',
                ]"
              >
                Detail
              </button>
            </div>

            <!-- 标签内容 -->
            <div class="p-8">
              <!-- 概述 -->
              <div class="space-y-4">
                <div
                  id="pro-detail-content"
                  v-html="currentProductDetails.detail"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Headers from "@/components/Headers.vue";
import Footer from "@/components/Footer.vue";
import ProductCarousel from "@/components/ProductCarousel.vue";
import { productList } from "../data/data";
export default {
  name: "ProductInfo",
  components: {
    Headers,
    Footer,
    ProductCarousel,
  },
  data() {
    return {
      product: {
        name: "Cool Series SPC06",
        subTitle: "4K 超高清运动相机",
        description:
          "使用 COOAU 运动相机 CU-SPC06 制作您自己的 VLOG。配备 4K 30FPS 20MP 高清摄像，支持 WiFi 连接和远程控制，40M 防水，2*1200mAh 电池和 20 个配件。",
        images: [
          "https://cdn.shopify.com/s/files/1/0265/1140/9257/products/2_9b31a275-1c0b-49cb-9fa4-3bc21c43544e_1080x.jpg?v=1622538251",
          "https://cdn.shopify.com/s/files/1/0265/1140/9257/products/2_9b31a275-1c0b-49cb-9fa4-3bc21c43544e_1080x.jpg?v=1622538251",
          "https://cdn.shopify.com/s/files/1/0265/1140/9257/products/2_9b31a275-1c0b-49cb-9fa4-3bc21c43544e_1080x.jpg?v=1622538251",
          "https://cdn.shopify.com/s/files/1/0265/1140/9257/products/2_9b31a275-1c0b-49cb-9fa4-3bc21c43544e_1080x.jpg?v=1622538251",
          "https://cdn.shopify.com/s/files/1/0265/1140/9257/products/2_9b31a275-1c0b-49cb-9fa4-3bc21c43544e_1080x.jpg?v=1622538251",
        ],
        overview:
          "这款 COOAU 运动相机 CU-SPC06 是您记录精彩瞬间的完美伙伴。无论是极限运动、水下探险还是日常 VLOG，它都能以 4K 超高清画质捕捉每一个细节。配备的 2 块 1200mAh 电池确保长时间使用，40 米防水性能让您无惧深海挑战。支持 WiFi 连接和 APP 控制，随时随地分享您的精彩时刻。",
      },
      currentImageIndex: 0,
      activeTab: "overview",
      autoplayTimer: null,
      tabs: [{ id: "overview", label: "概述" }],
      slideDirection: "slide-left",
      currentProductDetails: {},
    };
  },
  mounted() {
    productList.forEach((prod) => {
      if (prod.id == this.$route.query.id) {
        this.currentProductDetails = prod;
      }
    });
    console.log(this.currentProductDetails);
    this.startAutoplay();
  },
  beforeUnmount() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      this.autoplayTimer = setInterval(() => {
        this.nextImage();
      }, 3000); // 每 3 秒自动切换
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },
    pauseAutoplay() {
      this.stopAutoplay();
    },
    resumeAutoplay() {
      this.startAutoplay();
    },
    nextImage() {
      this.slideDirection = "slide-left";
      this.currentImageIndex =
        (this.currentImageIndex + 1) % this.product.images.length;
    },
    prevImage() {
      this.slideDirection = "slide-right";
      this.currentImageIndex =
        this.currentImageIndex === 0
          ? this.product.images.length - 1
          : this.currentImageIndex - 1;
    },
    goToImage(index) {
      this.slideDirection =
        index > this.currentImageIndex ? "slide-left" : "slide-right";
      this.currentImageIndex = index;
    },
    addToCart(path) {
      window.open(path, "_blank");
      // 这里可以添加购物车逻辑
    },
  },
};
</script>

<style scoped>
/* 移除了自定义动画，完全使用 Tailwind CSS */
</style>
